import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-rule-creation-chat-page',
  templateUrl: './rule-creation-chat-page.component.html',
  styleUrl: './rule-creation-chat-page.component.scss',
  standalone: false,
})
export class RuleCreationChatPageComponent {
  /** Active session equipment ID; passed in from the parent context */
  @Input() activeEquipmentId: string | null = null;
}
